import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, resolveComponent as _resolveComponent, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "list-page-panel is-header-minimal"
};
const _hoisted_2 = {
  class: "list-page-heading"
};
const _hoisted_3 = {
  class: "list-page-heading-actions"
};
const _hoisted_4 = {
  class: "space-y-3 flex min-h-0 flex-1 flex-col"
};
const _hoisted_5 = {
  class: "flex flex-wrap items-center gap-2 rounded-xl border border-slate-200 bg-white p-1 shadow-sm"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "grid gap-2.5 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-8"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "min-w-0 flex-1"
};
const _hoisted_10 = {
  class: "block text-[0.7rem] font-medium text-slate-500"
};
const _hoisted_11 = {
  class: "mt-0.5 block text-lg font-bold leading-none tracking-tight text-slate-900"
};
const _hoisted_12 = {
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_13 = ["disabled"];
const _hoisted_14 = ["disabled"];
const _hoisted_15 = {
  class: "data-table-shell"
};
const _hoisted_16 = {
  key: 0,
  class: "flex flex-1 flex-col items-center justify-center gap-3 px-6 py-16 text-center"
};
const _hoisted_17 = {
  class: "text-sm text-slate-500"
};
const _hoisted_18 = {
  key: 1,
  class: "flex flex-1 flex-col items-center justify-center gap-3 px-6 py-16 text-center"
};
const _hoisted_19 = {
  class: "flex h-12 w-12 items-center justify-center rounded-full bg-rose-100"
};
const _hoisted_20 = {
  class: "text-sm text-slate-600"
};
const _hoisted_21 = {
  key: 2,
  class: "flex flex-1 flex-col items-center justify-center gap-3 px-6 py-16 text-center"
};
const _hoisted_22 = {
  class: "flex h-12 w-12 items-center justify-center rounded-full bg-slate-100"
};
const _hoisted_23 = {
  class: "text-sm text-slate-500"
};
const _hoisted_24 = {
  key: 3,
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_25 = {
  class: "data-table min-w-[960px]"
};
const _hoisted_26 = {
  class: "data-table-body"
};
const _hoisted_27 = {
  class: "data-table-td"
};
const _hoisted_28 = {
  class: "min-w-0"
};
const _hoisted_29 = {
  class: "break-words font-medium text-slate-900"
};
const _hoisted_30 = {
  class: "mt-1 flex flex-wrap items-center gap-2 text-xs text-slate-500"
};
const _hoisted_31 = {
  key: 0
};
const _hoisted_32 = {
  class: "data-table-td text-slate-700"
};
const _hoisted_33 = {
  class: "data-table-td"
};
const _hoisted_34 = {
  class: "data-table-td"
};
const _hoisted_35 = {
  class: "data-table-td"
};
const _hoisted_36 = {
  class: "flex flex-wrap gap-1"
};
const _hoisted_37 = {
  key: 0,
  class: "status-badge is-warning"
};
const _hoisted_38 = {
  key: 1,
  class: "status-badge is-rose"
};
const _hoisted_39 = {
  key: 2,
  class: "status-badge is-info"
};
const _hoisted_40 = {
  key: 3,
  class: "status-badge is-orange"
};
const _hoisted_41 = {
  key: 4,
  class: "text-sm text-slate-500"
};
const _hoisted_42 = {
  class: "data-table-td text-right data-table-sticky-right data-table-sticky-action"
};
const _hoisted_43 = ["onClick"];
const _hoisted_44 = {
  class: "flex items-start justify-between gap-4 border-b border-slate-100 px-5 pb-4 pt-5"
};
const _hoisted_45 = {
  class: "min-w-0"
};
const _hoisted_46 = {
  class: "flex items-center gap-2.5"
};
const _hoisted_47 = {
  class: "flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-blue-50 text-blue-600"
};
const _hoisted_48 = {
  class: "text-base font-semibold text-slate-900"
};
const _hoisted_49 = ["disabled"];
const _hoisted_50 = {
  class: "space-y-4 px-5 py-5"
};
const _hoisted_51 = {
  class: "rounded-lg border border-slate-200 bg-white px-4 py-3"
};
const _hoisted_52 = {
  class: "flex flex-wrap items-center justify-between gap-2"
};
const _hoisted_53 = {
  class: "flex items-center gap-1.5"
};
const _hoisted_54 = ["disabled", "onClick"];
const _hoisted_55 = {
  class: "mt-2 flex items-center gap-2"
};
const _hoisted_56 = ["max", "disabled"];
const _hoisted_57 = ["min", "disabled"];
const _hoisted_58 = {
  class: "space-y-3.5 rounded-lg border border-slate-200 bg-white px-4 py-3"
};
const _hoisted_59 = {
  class: "flex items-center justify-between gap-2"
};
const _hoisted_60 = {
  key: 0,
  class: "rounded-full bg-blue-50 px-2 py-0.5 text-xs font-medium text-blue-600"
};
const _hoisted_61 = {
  class: "flex items-center justify-between gap-2"
};
const _hoisted_62 = {
  key: 0,
  class: "rounded-full bg-blue-50 px-2 py-0.5 text-xs font-medium text-blue-600"
};
const _hoisted_63 = {
  class: "flex items-center justify-between gap-3 border-t border-slate-100 bg-slate-50 px-5 py-4"
};
const _hoisted_64 = {
  class: "truncate text-xs text-slate-500"
};
const _hoisted_65 = {
  class: "flex shrink-0 gap-2"
};
const _hoisted_66 = ["disabled"];
const _hoisted_67 = ["disabled"];
import { computed, onMounted, reactive, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { ElMessage } from 'element-plus';
import { ArrowDownTrayIcon, EyeIcon, UserGroupIcon, CheckCircleIcon, ClockIcon, ExclamationCircleIcon, ExclamationTriangleIcon, InboxIcon, DocumentCheckIcon, Cog6ToothIcon, XMarkIcon } from '@heroicons/vue/24/outline';
import AppModal from '@/components/AppModal.vue';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import UserSelector from '@/components/UserSelector/index.vue';
import DeptSelector from '@/components/DeptSelector/index.vue';
import { commentTeamWorkReport, evaluateWorkReport, exportCopiedToMeWorkReports, exportTeamWorkReports, getCopiedToMeWorkReportDetail, getCopiedToMeWorkReportPage, getCopiedToMeWorkReportExportOptions, getCopiedToMeWorkReportStatistics, getCopiedToMeWorkReportVersion, getTeamWorkReportDetail, getTeamWorkReportPage, getTeamWorkReportExportOptions, getTeamWorkReportStatistics, getWorkReportAccessSummary, getTeamWorkReportVersion, requestWorkReportSupplement } from '@/api/workReport';
import { downloadBlob, resolveBlobErrorMessage } from '@/utils/download';
import { createClientRequestId, getReportOptimisticVersion } from './workReportUtils';
import { createWorkReportDetailOperationGuard, isSameWorkReport, isWorkReportVersionConflict } from './composables/workReportDetailOperationGuard.mjs';
import { createDefaultTeamWorkbenchStatusFilter } from './composables/workReportTeamWorkbench.mjs';
import DepartmentRuleDrawer from './components/DepartmentRuleDrawer.vue';
import ReportDetailDrawer from './components/ReportDetailDrawer.vue';
import ReportStatusBadge from './components/ReportStatusBadge.vue';
const TEAM_SCOPE = 'team';
const COPIED_SCOPE = 'copied';
const MAX_EXPORT_RANGE_DAYS = 92;
export default {
  __name: 'TeamWorkReport',
  setup(__props) {
    const route = useRoute();
    const scopeTabs = [{
      value: TEAM_SCOPE,
      label: '直属团队'
    }, {
      value: COPIED_SCOPE,
      label: '抄送我的'
    }];
    const initialStatusFilter = createDefaultTeamWorkbenchStatusFilter();
    const activeScope = ref(TEAM_SCOPE);
    const query = reactive({
      reportDate: localDate(),
      employeeUserId: '',
      deptId: '',
      planStatus: initialStatusFilter.planStatus,
      summaryStatus: initialStatusFilter.summaryStatus,
      exceptionType: '',
      current: 1,
      size: 10
    });
    const selectedEmployee = ref(null);
    const selectedDept = ref(null);
    // 导出弹窗：打开时默认区间跟随当前搜索日期（单日）、员工/部门跟随页面筛选（转为多选数组），弹窗内可调整；
    // 员工/部门多选下拉仅展示当前范围内可操作选项（团队=主管授权成员，抄送=区间内抄送来源）
    const EXPORT_RANGE_PRESETS = [{
      label: '今天',
      days: 0
    }, {
      label: '近7天',
      days: 6
    }, {
      label: '近30天',
      days: 29
    }];
    const exporting = ref(false);
    const showExportModal = ref(false);
    const exportRange = ref({
      startDate: '',
      endDate: ''
    });
    const exportEmployeeUserIds = ref([]);
    const exportDeptIds = ref([]);
    const exportOptions = ref({
      employees: [],
      depts: []
    });
    const exportOptionsLoading = ref(false);

    // 部门下拉附带人数（按当前可选员工统计），便于主管判断导出规模
    const exportDeptOptionRows = computed(() => {
      const counts = {};
      for (const employee of exportOptions.value.employees) {
        if (employee.deptId === null || employee.deptId === undefined) continue;
        counts[employee.deptId] = (counts[employee.deptId] || 0) + 1;
      }
      return exportOptions.value.depts.map(dept => ({
        id: dept.id,
        label: counts[dept.id] ? `${dept.name}（${counts[dept.id]}人）` : dept.name
      }));
    });
    const exportRangeDays = computed(() => {
      const {
        startDate,
        endDate
      } = exportRange.value;
      if (!startDate || !endDate || startDate > endDate) return 0;
      return Math.round((new Date(endDate) - new Date(startDate)) / 86400000) + 1;
    });
    const exportSummaryText = computed(() => {
      const parts = [];
      if (exportRangeDays.value > 0) parts.push(`${exportRangeDays.value} 天`);
      if (exportEmployeeUserIds.value.length) parts.push(`${exportEmployeeUserIds.value.length} 名员工`);
      if (exportDeptIds.value.length) parts.push(`${exportDeptIds.value.length} 个部门`);
      return parts.length ? `将导出 ${parts.join(' · ')}` : '将导出全部可见范围';
    });
    const rows = ref([]);
    const statistics = ref(emptyStatistics());
    const pagination = reactive({
      current: 1,
      size: 10,
      total: 0,
      pages: 1
    });
    const loading = ref(false);
    const statisticsLoading = ref(false);
    const loadError = ref(false);
    const drawerVisible = ref(false);
    const workReportAccessSummary = ref(defaultWorkReportAccessSummary());
    const departmentRuleDrawerVisible = ref(false);
    const detailLoading = ref(false);
    const detailVersionLoading = ref(false);
    const selectedDetail = ref(null);
    const selectedDetailVersion = ref(null);
    const selectedReportId = ref(null);
    const detailInitialTab = ref('comparison');
    const notificationFocusCommentId = ref('');
    const evaluationSubmitting = ref(false);
    const supplementSubmitting = ref(false);
    const detailOperationSubmitting = ref(false);
    const supplementResetToken = ref(0);
    const detailOperationGuard = createWorkReportDetailOperationGuard();
    let listRequestToken = 0;
    let detailRequestToken = 0;
    let detailVersionRequestToken = 0;
    const canManageDepartmentRules = computed(() => Boolean(workReportAccessSummary.value?.ruleManageVisible));
    const detailSummarySubmitted = computed(() => (selectedDetail.value?.statusSummary?.summaryStatus || selectedDetail.value?.summaryStatus) === 'SUBMITTED');
    const detailCanEvaluate = computed(() => detailSummarySubmitted.value && detailHasAction('EVALUATE'));
    const detailCanRequestSupplement = computed(() => detailSummarySubmitted.value && detailHasAction('REQUEST_SUPPLEMENT'));
    const detailCanComment = computed(() => detailHasAction('COMMENT'));
    const canOperateOnDetail = computed(() => detailCanEvaluate.value);
    const filteredRows = computed(() => rows.value.filter(matchesExceptionType));
    const loadingText = computed(() => activeScope.value === COPIED_SCOPE ? '正在加载抄送我的日报...' : '正在加载团队日报...');
    const loadErrorText = computed(() => activeScope.value === COPIED_SCOPE ? '抄送我的日报加载失败，请稍后重试。' : '团队日报加载失败，请稍后重试。');
    const exportDialogTitle = computed(() => activeScope.value === COPIED_SCOPE ? '导出抄送我的日报' : '导出团队日报');
    const emptyText = computed(() => activeScope.value === COPIED_SCOPE ? '暂无抄送我的日报' : '暂无符合条件的团队日报');
    const summaryCards = computed(() => [{
      key: 'scopeTotal',
      label: activeScope.value === COPIED_SCOPE ? '抄送我的' : '所辖员工',
      value: scopeTotal(statistics.value),
      hint: '当前范围总数',
      tone: 'text-slate-500',
      icon: UserGroupIcon,
      iconBg: 'bg-slate-100',
      iconColor: 'text-slate-600',
      filter: {
        planStatus: '',
        summaryStatus: '',
        exceptionType: ''
      },
      active: !query.planStatus && !query.summaryStatus && !query.exceptionType
    }, {
      key: 'planSubmitted',
      label: '计划已交',
      value: numberValue(statistics.value.planSubmitted),
      hint: '计划阶段完成',
      tone: 'text-emerald-600',
      icon: CheckCircleIcon,
      iconBg: 'bg-emerald-100',
      iconColor: 'text-emerald-600',
      filter: {
        planStatus: 'SUBMITTED',
        summaryStatus: '',
        exceptionType: ''
      },
      active: query.planStatus === 'SUBMITTED' && !query.summaryStatus && !query.exceptionType
    }, {
      key: 'planUnsubmitted',
      label: '计划未交',
      value: numberValue(statistics.value.planUnsubmitted),
      hint: '计划尚未提交',
      tone: 'text-rose-600',
      icon: ExclamationTriangleIcon,
      iconBg: 'bg-rose-100',
      iconColor: 'text-rose-600',
      filter: {
        planStatus: 'DRAFT',
        summaryStatus: '',
        exceptionType: ''
      },
      active: query.planStatus === 'DRAFT' && !query.summaryStatus && !query.exceptionType
    }, {
      key: 'summarySubmitted',
      label: '总结已交',
      value: numberValue(statistics.value.summarySubmitted),
      hint: '总结阶段完成',
      tone: 'text-emerald-600',
      icon: DocumentCheckIcon,
      iconBg: 'bg-emerald-100',
      iconColor: 'text-emerald-600',
      filter: {
        planStatus: '',
        summaryStatus: 'SUBMITTED',
        exceptionType: ''
      },
      active: !query.planStatus && query.summaryStatus === 'SUBMITTED' && !query.exceptionType
    }, {
      key: 'summaryUnsubmitted',
      label: '总结未交',
      value: numberValue(statistics.value.summaryUnsubmitted),
      hint: '总结尚未提交',
      tone: 'text-rose-600',
      icon: ExclamationTriangleIcon,
      iconBg: 'bg-rose-100',
      iconColor: 'text-rose-600',
      filter: {
        planStatus: '',
        summaryStatus: 'DRAFT',
        exceptionType: ''
      },
      active: !query.planStatus && query.summaryStatus === 'DRAFT' && !query.exceptionType
    }, {
      key: 'late',
      label: '存在迟交',
      value: numberValue(statistics.value.late),
      hint: '点击筛选迟交',
      tone: 'text-amber-600',
      icon: ClockIcon,
      iconBg: 'bg-amber-100',
      iconColor: 'text-amber-600',
      filter: {
        planStatus: '',
        summaryStatus: '',
        exceptionType: 'LATE'
      },
      active: query.exceptionType === 'LATE'
    }, {
      key: 'awaitingEvaluation',
      label: '待评价',
      value: numberValue(statistics.value.awaitingEvaluation),
      hint: '点击筛选待评价',
      tone: 'text-blue-600',
      icon: ExclamationCircleIcon,
      iconBg: 'bg-blue-100',
      iconColor: 'text-blue-600',
      filter: {
        planStatus: '',
        summaryStatus: '',
        exceptionType: 'PENDING_EVALUATION'
      },
      active: query.exceptionType === 'PENDING_EVALUATION'
    }, {
      key: 'supplementRequested',
      label: '待补充',
      value: numberValue(statistics.value.supplementRequested),
      hint: '点击筛选待补充',
      tone: 'text-orange-600',
      icon: ExclamationCircleIcon,
      iconBg: 'bg-orange-100',
      iconColor: 'text-orange-600',
      filter: {
        planStatus: '',
        summaryStatus: '',
        exceptionType: 'PENDING_SUPPLEMENT'
      },
      active: query.exceptionType === 'PENDING_SUPPLEMENT'
    }]);
    onMounted(async () => {
      await fetchWorkReportAccessSummary();
      await loadPage();
      await openDetailFromRouteQuery();
    });
    watch(() => route.query, () => {
      openDetailFromRouteQuery();
    });
    async function loadPage() {
      const requestToken = ++listRequestToken;
      loading.value = true;
      statisticsLoading.value = true;
      loadError.value = false;
      try {
        const [page, scopeStatistics] = await Promise.all([activePageApi()(requestParams()), loadStatistics()]);
        if (requestToken !== listRequestToken) return;
        rows.value = pageRows(page);
        statistics.value = normalizeStatistics(scopeStatistics);
        pagination.current = Number(page?.current) || query.current;
        pagination.size = Number(page?.size) || query.size;
        pagination.total = Number(page?.total) || 0;
        pagination.pages = Number(page?.pages) || Math.max(1, Math.ceil(pagination.total / pagination.size) || 1);
      } catch {
        if (requestToken !== listRequestToken) return;
        rows.value = [];
        statistics.value = emptyStatistics();
        loadError.value = true;
      } finally {
        if (requestToken === listRequestToken) {
          loading.value = false;
          statisticsLoading.value = false;
        }
      }
    }
    async function loadStatistics() {
      return normalizeStatistics(await activeStatisticsApi()(statisticsRequestParams()));
    }
    function requestParams() {
      return {
        ...baseRequestParams(),
        planStatus: query.planStatus || undefined,
        summaryStatus: query.summaryStatus || undefined,
        exceptionType: query.exceptionType || undefined,
        current: query.current,
        size: query.size
      };
    }
    function statisticsRequestParams() {
      return baseRequestParams();
    }
    function baseRequestParams() {
      return {
        reportDate: query.reportDate || undefined,
        employeeUserId: query.employeeUserId || undefined,
        deptId: query.deptId || undefined
      };
    }
    function activePageApi() {
      return activeScope.value === COPIED_SCOPE ? getCopiedToMeWorkReportPage : getTeamWorkReportPage;
    }
    function activeStatisticsApi() {
      return activeScope.value === COPIED_SCOPE ? getCopiedToMeWorkReportStatistics : getTeamWorkReportStatistics;
    }
    function activeDetailApi() {
      return activeScope.value === COPIED_SCOPE ? getCopiedToMeWorkReportDetail : getTeamWorkReportDetail;
    }
    function activeVersionApi() {
      return activeScope.value === COPIED_SCOPE ? getCopiedToMeWorkReportVersion : getTeamWorkReportVersion;
    }
    function pageRows(page) {
      if (Array.isArray(page?.records)) return page.records;
      if (Array.isArray(page?.list)) return page.list;
      if (Array.isArray(page?.items)) return page.items;
      return [];
    }
    function emptyStatistics() {
      return {
        employeeTotal: 0,
        copiedToMeTotal: 0,
        planSubmitted: 0,
        planUnsubmitted: 0,
        summarySubmitted: 0,
        summaryUnsubmitted: 0,
        planMissing: 0,
        summaryMissing: 0,
        late: 0,
        awaitingEvaluation: 0,
        supplementRequested: 0
      };
    }
    function defaultWorkReportAccessSummary() {
      return {
        selfReportVisible: true,
        teamWorkbenchVisible: false,
        ruleManageVisible: false,
        defaultTeamScope: 'TEAM'
      };
    }
    async function fetchWorkReportAccessSummary() {
      try {
        workReportAccessSummary.value = {
          ...defaultWorkReportAccessSummary(),
          ...((await getWorkReportAccessSummary()) || {})
        };
      } catch (error) {
        console.error('加载日报入口权限失败:', error);
        workReportAccessSummary.value = defaultWorkReportAccessSummary();
      }
    }
    function normalizeStatistics(value) {
      return {
        ...emptyStatistics(),
        ...(value && typeof value === 'object' ? value : {})
      };
    }
    function numberValue(value) {
      return Number(value) || 0;
    }
    function scopeTotal(value) {
      return activeScope.value === COPIED_SCOPE ? numberValue(value?.copiedToMeTotal) : numberValue(value?.employeeTotal);
    }
    function detailHasAction(action) {
      const actions = selectedDetail.value?.detailContext?.availableActions;
      return Array.isArray(actions) && actions.includes(action);
    }
    function matchesExceptionType(row) {
      return Boolean(row);
    }
    function phaseDisplayStatus(row, phase) {
      const missingField = phase === 'plan' ? 'planMissing' : 'summaryMissing';
      const lateField = phase === 'plan' ? 'planLate' : 'summaryLate';
      if (row?.[missingField]) return 'MISSING';
      if (row?.[lateField]) return 'LATE';
      return row?.[`${phase}Status`] || 'DRAFT';
    }
    function handleSearch() {
      query.current = 1;
      loadPage();
    }
    function openExportDialog() {
      const baseDate = query.reportDate || localDate();
      exportRange.value = {
        startDate: baseDate,
        endDate: baseDate
      };
      exportEmployeeUserIds.value = query.employeeUserId ? [Number(query.employeeUserId)] : [];
      exportDeptIds.value = query.deptId ? [Number(query.deptId)] : [];
      showExportModal.value = true;
      loadExportOptions();
    }
    function closeExportDialog() {
      if (exporting.value) return;
      clearTimeout(exportOptionsReloadTimer);
      showExportModal.value = false;
    }
    function localDateBefore(daysAgo) {
      const now = new Date();
      now.setDate(now.getDate() - daysAgo);
      const offset = now.getTimezoneOffset();
      return new Date(now.getTime() - offset * 60 * 1000).toISOString().slice(0, 10);
    }
    function applyExportPreset(preset) {
      if (exporting.value) return;
      exportRange.value = {
        startDate: localDateBefore(preset.days),
        endDate: localDateBefore(0)
      };
    }
    function isExportPresetActive(preset) {
      return exportRange.value.endDate === localDateBefore(0) && exportRange.value.startDate === localDateBefore(preset.days);
    }
    async function loadExportOptions() {
      exportOptionsLoading.value = true;
      try {
        const optionsApi = activeScope.value === COPIED_SCOPE ? getCopiedToMeWorkReportExportOptions : getTeamWorkReportExportOptions;
        const data = await optionsApi({
          startDate: exportRange.value.startDate || undefined,
          endDate: exportRange.value.endDate || undefined
        });
        exportOptions.value = {
          employees: Array.isArray(data?.employees) ? data.employees : [],
          depts: Array.isArray(data?.depts) ? data.depts : []
        };
        // 已选值若不在可操作范围内则剔除（如页面筛选带入的范围外默认值）
        const validEmployeeIds = new Set(exportOptions.value.employees.map(item => String(item.id)));
        exportEmployeeUserIds.value = exportEmployeeUserIds.value.filter(id => validEmployeeIds.has(String(id)));
        const validDeptIds = new Set(exportOptions.value.depts.map(item => String(item.id)));
        exportDeptIds.value = exportDeptIds.value.filter(id => validDeptIds.has(String(id)));
      } catch {
        exportOptions.value = {
          employees: [],
          depts: []
        };
        exportEmployeeUserIds.value = [];
        exportDeptIds.value = [];
        ElMessage.warning('可选员工/部门加载失败，将按"全部"范围导出');
      } finally {
        exportOptionsLoading.value = false;
      }
    }

    // 弹窗打开期间调整日期区间时刷新可选项（团队成员按结束日解析、抄送来源按区间解析）
    // 去抖刷新：日期选择器连续提交（先改起、再改止）合并为一次请求，减少加载态闪烁
    let exportOptionsReloadTimer = 0;
    watch(() => [exportRange.value.startDate, exportRange.value.endDate], () => {
      if (!showExportModal.value || exporting.value) return;
      clearTimeout(exportOptionsReloadTimer);
      exportOptionsReloadTimer = setTimeout(() => loadExportOptions(), 250);
    });
    async function handleExport() {
      if (exporting.value) return;
      const {
        startDate,
        endDate
      } = exportRange.value;
      if (!startDate || !endDate) {
        ElMessage.warning('请先选择导出的开始与结束日期');
        return;
      }
      if (startDate > endDate) {
        ElMessage.warning('导出开始日期不能晚于结束日期');
        return;
      }
      if (exportRangeDays.value > MAX_EXPORT_RANGE_DAYS) {
        ElMessage.warning(`导出日期区间不能超过 ${MAX_EXPORT_RANGE_DAYS} 天，请缩小范围`);
        return;
      }
      exporting.value = true;
      try {
        const exportApi = activeScope.value === COPIED_SCOPE ? exportCopiedToMeWorkReports : exportTeamWorkReports;
        const {
          blob,
          fileName
        } = await exportApi({
          startDate,
          endDate,
          // 多选 ID 以逗号分隔串传递，后端绑定为 List<Long>
          employeeUserIds: exportEmployeeUserIds.value.length ? exportEmployeeUserIds.value.join(',') : undefined,
          deptIds: exportDeptIds.value.length ? exportDeptIds.value.join(',') : undefined,
          planStatus: query.planStatus || undefined,
          summaryStatus: query.summaryStatus || undefined,
          exceptionType: query.exceptionType || undefined
        });
        downloadBlob(blob, fileName);
        showExportModal.value = false;
        ElMessage.success('导出成功');
      } catch (error) {
        ElMessage.error(await resolveBlobErrorMessage(error, '导出失败，请稍后重试'));
      } finally {
        exporting.value = false;
      }
    }
    function switchScope(scope) {
      if (scope !== TEAM_SCOPE && scope !== COPIED_SCOPE) return;
      if (activeScope.value === scope) return;
      activeScope.value = scope;
      Object.assign(query, createDefaultTeamWorkbenchStatusFilter());
      query.exceptionType = '';
      query.current = 1;
      handleDrawerVisibleChange(false);
      loadPage();
    }
    function resetFilters() {
      query.reportDate = localDate();
      query.employeeUserId = '';
      query.deptId = '';
      Object.assign(query, createDefaultTeamWorkbenchStatusFilter());
      query.exceptionType = '';
      selectedEmployee.value = null;
      selectedDept.value = null;
      query.current = 1;
      loadPage();
    }
    function openDepartmentRuleDrawer() {
      if (!canManageDepartmentRules.value) return;
      departmentRuleDrawerVisible.value = true;
    }
    function handleEmployeeConfirm(users) {
      const [user] = Array.isArray(users) ? users : [];
      selectedEmployee.value = user || null;
      query.employeeUserId = normalizeSelectorId(user || selectedEmployee.value);
      handleSearch();
    }
    function handleEmployeeChange(value) {
      selectedEmployee.value = value;
      query.employeeUserId = normalizeSelectorId(value);
      if (!query.employeeUserId) handleSearch();
    }
    function handleDeptChange(value) {
      selectedDept.value = value;
      query.deptId = normalizeSelectorId(value);
      handleSearch();
    }
    function normalizeSelectorId(value) {
      if (Array.isArray(value)) return normalizeSelectorId(value[0]);
      if (value && typeof value === 'object') return value.id ?? '';
      return value || '';
    }
    function applySummaryFilter(card) {
      if (!card?.filter) return;
      Object.assign(query, card.filter);
      handleSearch();
    }
    function handlePageChange(current) {
      query.current = current;
      loadPage();
    }
    function handleSizeChange(size) {
      query.size = size;
      query.current = 1;
      loadPage();
    }
    async function openDetail(row) {
      if (!row?.reportId) {
        ElMessage.warning('该员工当天尚未生成日报，无法打开详情');
        return;
      }
      detailInitialTab.value = 'comparison';
      notificationFocusCommentId.value = '';
      selectedReportId.value = row.reportId;
      selectedDetail.value = null;
      selectedDetailVersion.value = null;
      detailVersionRequestToken += 1;
      detailVersionLoading.value = false;
      drawerVisible.value = true;
      await loadDetail(row.reportId);
    }
    async function openDetailByReportId(reportId) {
      if (!reportId) return;
      selectedReportId.value = reportId;
      selectedDetail.value = null;
      selectedDetailVersion.value = null;
      detailVersionRequestToken += 1;
      detailVersionLoading.value = false;
      drawerVisible.value = true;
      await loadDetail(reportId);
    }
    async function openDetailFromRouteQuery() {
      const routeReportId = normalizeRouteId(route.query.reportId || route.query.id);
      const routeDate = normalizeReportDateQuery(route.query.reportDate);
      const routeScope = normalizeRouteId(route.query.scope);
      const wantsFeedback = isTruthyRouteFlag(route.query.feedback);
      const wantsEvaluation = isTruthyRouteFlag(route.query.evaluation);
      const wantsOpenRules = isTruthyRouteFlag(route.query.openRules);
      notificationFocusCommentId.value = normalizeRouteId(route.query.commentId);
      detailInitialTab.value = wantsEvaluation ? 'evaluation' : wantsFeedback ? 'comments' : 'comparison';
      if (routeDate) query.reportDate = routeDate;
      if (routeScope === COPIED_SCOPE) activeScope.value = COPIED_SCOPE;else if (routeScope === TEAM_SCOPE) activeScope.value = TEAM_SCOPE;
      if (wantsOpenRules) {
        openDepartmentRuleDrawer();
      }
      if (!routeReportId) return;
      await openDetailByReportId(routeReportId);
    }
    async function loadDetail(reportId) {
      const requestToken = ++detailRequestToken;
      detailLoading.value = true;
      try {
        const detail = await activeDetailApi()(reportId);
        if (requestToken !== detailRequestToken || !isCurrentSelectedReport(reportId)) return;
        selectedDetail.value = detail;
      } catch {
        if (requestToken !== detailRequestToken || !isCurrentSelectedReport(reportId)) return;
        ElMessage.error('日报详情加载失败，请稍后重试');
        handleDrawerVisibleChange(false);
      } finally {
        if (requestToken === detailRequestToken && isCurrentSelectedReport(reportId)) detailLoading.value = false;
      }
    }
    function handleDrawerVisibleChange(visible) {
      drawerVisible.value = visible;
      if (!visible) {
        selectedReportId.value = null;
        selectedDetail.value = null;
        selectedDetailVersion.value = null;
        detailRequestToken += 1;
        detailVersionRequestToken += 1;
        detailLoading.value = false;
        detailVersionLoading.value = false;
      }
    }
    function isCurrentSelectedReport(reportId) {
      return drawerVisible.value && isSameWorkReport(reportId, selectedReportId.value);
    }
    async function refreshDetailIfSelected(reportId) {
      if (isCurrentSelectedReport(reportId)) {
        selectedDetailVersion.value = null;
        detailVersionRequestToken += 1;
        detailVersionLoading.value = false;
        await loadDetail(reportId);
      }
    }
    async function loadDetailVersion(version) {
      const reportId = selectedDetail.value?.reportId ?? selectedDetail.value?.id ?? selectedReportId.value;
      if (!reportId || !version?.phase || !version?.versionNo) {
        selectedDetailVersion.value = null;
        return;
      }
      const requestToken = ++detailVersionRequestToken;
      detailVersionLoading.value = true;
      try {
        const snapshot = await activeVersionApi()(reportId, version.phase, version.versionNo);
        if (requestToken !== detailVersionRequestToken || !isCurrentSelectedReport(reportId)) return;
        selectedDetailVersion.value = snapshot;
      } catch {
        if (requestToken !== detailVersionRequestToken || !isCurrentSelectedReport(reportId)) return;
        ElMessage.error('版本内容加载失败，请稍后重试');
      } finally {
        if (requestToken === detailVersionRequestToken && isCurrentSelectedReport(reportId)) {
          detailVersionLoading.value = false;
        }
      }
    }
    function beginDetailOperation(phase, action = 'EVALUATE') {
      const detail = selectedDetail.value;
      const reportId = detail?.reportId ?? detail?.id;
      if (!reportId || !detailHasAction(action)) return null;
      const operation = detailOperationGuard.acquire(reportId, phase);
      if (!operation) return null;
      detailOperationSubmitting.value = true;
      return {
        detail,
        operation
      };
    }
    function finishDetailOperation(operation) {
      detailOperationGuard.release(operation);
      detailOperationSubmitting.value = detailOperationGuard.isLocked();
    }
    async function handleDetailOperationFailure(error, reportId, fallbackMessage) {
      if (isWorkReportVersionConflict(error)) {
        ElMessage.warning('当前日报已被其他操作更新，正在刷新最新详情');
        await refreshDetailIfSelected(reportId);
        return;
      }
      ElMessage.error(fallbackMessage);
    }
    async function handleEvaluation(evaluation) {
      const started = beginDetailOperation('SUMMARY', 'EVALUATE');
      if (!started) return;
      const {
        detail,
        operation
      } = started;
      evaluationSubmitting.value = true;
      try {
        await evaluateWorkReport(operation.reportId, {
          phase: 'SUMMARY',
          grade: evaluation.grade,
          comment: evaluation.comment,
          expectedVersion: getReportOptimisticVersion(detail),
          clientRequestId: createClientRequestId()
        });
        ElMessage.success('评价已提交');
        await refreshDetailIfSelected(operation.reportId);
        await loadPage();
      } catch (error) {
        await handleDetailOperationFailure(error, operation.reportId, '评价提交失败，请稍后重试');
      } finally {
        evaluationSubmitting.value = false;
        finishDetailOperation(operation);
      }
    }
    async function handleSupplement(supplement) {
      if (!supplement?.content) return;
      const started = beginDetailOperation('SUMMARY', 'REQUEST_SUPPLEMENT');
      if (!started) return;
      const {
        detail,
        operation
      } = started;
      supplementSubmitting.value = true;
      try {
        await requestWorkReportSupplement(operation.reportId, {
          content: supplement.content,
          expectedVersion: getReportOptimisticVersion(detail),
          clientRequestId: createClientRequestId()
        });
        ElMessage.success('已请求补充');
        supplementResetToken.value += 1;
        await refreshDetailIfSelected(operation.reportId);
        await loadPage();
      } catch (error) {
        await handleDetailOperationFailure(error, operation.reportId, '请求补充失败，请稍后重试');
      } finally {
        supplementSubmitting.value = false;
        finishDetailOperation(operation);
      }
    }
    async function handleComment(comment) {
      if (!comment?.content || !selectedDetail.value) return;
      if (!detailCanComment.value) return;
      const reportId = selectedDetail.value.reportId ?? selectedDetail.value.id;
      if (!reportId) return;
      detailOperationSubmitting.value = true;
      try {
        await commentTeamWorkReport(reportId, {
          parentCommentId: comment.parentCommentId || null,
          content: comment.content,
          clientRequestId: createClientRequestId()
        });
        ElMessage.success('评论已提交');
        await refreshDetailIfSelected(reportId);
      } catch {
        ElMessage.error('评论提交失败，请稍后重试');
      } finally {
        detailOperationSubmitting.value = detailOperationGuard.isLocked();
      }
    }
    function employeeLabel(row) {
      if (typeof row?.employee === 'string') return row.employee;
      return row?.employee?.name || row?.employee?.realName || row?.employeeName || '--';
    }
    function departmentLabel(row) {
      if (typeof row?.dept === 'string') return row.dept;
      return row?.dept?.name || row?.deptName || '--';
    }
    function localDate() {
      const now = new Date();
      const offset = now.getTimezoneOffset();
      return new Date(now.getTime() - offset * 60 * 1000).toISOString().slice(0, 10);
    }
    function normalizeRouteId(value) {
      const text = Array.isArray(value) ? value[0] : value;
      return text === null || text === undefined || text === '' ? '' : String(text);
    }
    function normalizeReportDateQuery(value) {
      const text = Array.isArray(value) ? value[0] : value;
      return /^\d{4}-\d{2}-\d{2}$/.test(String(text || '')) ? text : '';
    }
    function isTruthyRouteFlag(value) {
      const text = Array.isArray(value) ? value[0] : value;
      return text === true || text === '1' || text === 'true';
    }
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[9] || (_cache[9] = _createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "团队日报"), _createElementVNode("p", {
          class: "list-page-description"
        }, "查看直属团队日报提交、评价与补充情况。")], -1)), _createElementVNode("div", _hoisted_3, [canManageDepartmentRules.value ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "btn-secondary inline-flex items-center gap-1.5",
          onClick: openDepartmentRuleDrawer
        }, [_createVNode(_unref(Cog6ToothIcon), {
          class: "h-4 w-4"
        }), _cache[8] || (_cache[8] = _createTextVNode(" 部门规则 ", -1))])) : _createCommentVNode("", true)])])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("section", _hoisted_5, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(scopeTabs, scope => {
          return _createElementVNode("button", {
            key: scope.value,
            type: "button",
            class: _normalizeClass(["rounded-lg px-4 py-2 text-sm font-medium transition-colors", activeScope.value === scope.value ? 'bg-blue-600 text-white shadow-sm' : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900']),
            onClick: $event => switchScope(scope.value)
          }, _toDisplayString(scope.label), 11, _hoisted_6);
        }), 64))]), _createElementVNode("section", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summaryCards.value, card => {
          return _openBlock(), _createElementBlock("button", {
            key: card.key,
            type: "button",
            class: _normalizeClass(["group flex items-start gap-2.5 rounded-lg border bg-white p-3 text-left shadow-sm transition-all duration-200 hover:shadow-md", card.active ? 'border-blue-300 bg-blue-50/60 ring-1 ring-blue-200' : 'border-slate-200 hover:border-blue-200']),
            onClick: $event => applySummaryFilter(card)
          }, [_createElementVNode("div", {
            class: _normalizeClass(["flex h-8 w-8 items-center justify-center rounded-lg shrink-0", card.iconBg])
          }, [(_openBlock(), _createBlock(_resolveDynamicComponent(card.icon), {
            class: _normalizeClass(["h-4 w-4", card.iconColor])
          }, null, 8, ["class"]))], 2), _createElementVNode("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString(card.label), 1), _createElementVNode("span", _hoisted_11, _toDisplayString(card.value), 1), _createElementVNode("span", {
            class: _normalizeClass(["mt-0.5 block text-[0.65rem] font-medium", card.tone])
          }, _toDisplayString(card.hint), 3)])], 10, _hoisted_8);
        }), 128))]), _createElementVNode("div", _hoisted_12, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          "refresh-loading": loading.value || statisticsLoading.value,
          onRefresh: loadPage
        }, {
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            disabled: loading.value,
            onClick: handleSearch
          }, "搜索", 8, _hoisted_13), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            disabled: loading.value,
            onClick: resetFilters
          }, "重置", 8, _hoisted_14), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary inline-flex items-center gap-1.5",
            title: "按当前范围与筛选条件导出日报 xlsx",
            onClick: openExportDialog
          }, [_createVNode(_unref(ArrowDownTrayIcon), {
            class: "h-4 w-4"
          }), _cache[10] || (_cache[10] = _createTextVNode(" 导出 ", -1))])]),
          default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => query.reportDate = $event),
            class: "form-input form-control-sm filter-bar-field",
            type: "date",
            onChange: handleSearch
          }, null, 544), [[_vModelText, query.reportDate]]), _createVNode(UserSelector, {
            modelValue: selectedEmployee.value,
            "onUpdate:modelValue": [_cache[1] || (_cache[1] = $event => selectedEmployee.value = $event), handleEmployeeChange],
            class: "form-control-sm filter-bar-field",
            multiple: false,
            placeholder: "选择员工",
            onConfirm: handleEmployeeConfirm
          }, null, 8, ["modelValue"]), _createVNode(DeptSelector, {
            modelValue: selectedDept.value,
            "onUpdate:modelValue": [_cache[2] || (_cache[2] = $event => selectedDept.value = $event), handleDeptChange],
            class: "form-control-sm filter-bar-field",
            multiple: false,
            placeholder: "选择部门"
          }, null, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_15, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_cache[11] || (_cache[11] = _createElementVNode("div", {
          class: "app-spinner"
        }, null, -1)), _createElementVNode("span", _hoisted_17, _toDisplayString(loadingText.value), 1)])) : loadError.value ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createVNode(_unref(ExclamationTriangleIcon), {
          class: "h-6 w-6 text-rose-500"
        })]), _createElementVNode("p", _hoisted_20, _toDisplayString(loadErrorText.value), 1), _createElementVNode("button", {
          type: "button",
          class: "btn-secondary mt-1",
          onClick: loadPage
        }, "重试")])) : filteredRows.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createVNode(_unref(InboxIcon), {
          class: "h-6 w-6 text-slate-400"
        })]), _createElementVNode("span", _hoisted_23, _toDisplayString(emptyText.value), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("table", _hoisted_25, [_cache[12] || (_cache[12] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "data-table-th text-left"
        }, "员工"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "部门"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "计划"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "总结"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "提醒"), _createElementVNode("th", {
          class: "data-table-th text-right data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作")])], -1)), _createElementVNode("tbody", _hoisted_26, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredRows.value, row => {
          return _openBlock(), _createElementBlock("tr", {
            key: row.reportId || `${row.employeeUserId}-${row.reportDate}`,
            class: "transition-colors hover:bg-slate-50/80"
          }, [_createElementVNode("td", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, _toDisplayString(employeeLabel(row)), 1), _createElementVNode("div", _hoisted_30, [_createElementVNode("span", null, _toDisplayString(row.reportDate || '--'), 1), row.employeeUserId ? (_openBlock(), _createElementBlock("span", _hoisted_31, "ID " + _toDisplayString(row.employeeUserId), 1)) : _createCommentVNode("", true)])])]), _createElementVNode("td", _hoisted_32, _toDisplayString(departmentLabel(row)), 1), _createElementVNode("td", _hoisted_33, [_createVNode(ReportStatusBadge, {
            status: phaseDisplayStatus(row, 'plan')
          }, null, 8, ["status"])]), _createElementVNode("td", _hoisted_34, [_createVNode(ReportStatusBadge, {
            status: phaseDisplayStatus(row, 'summary')
          }, null, 8, ["status"])]), _createElementVNode("td", _hoisted_35, [_createElementVNode("div", _hoisted_36, [row.planLate || row.summaryLate ? (_openBlock(), _createElementBlock("span", _hoisted_37, "迟交")) : _createCommentVNode("", true), row.planMissing || row.summaryMissing ? (_openBlock(), _createElementBlock("span", _hoisted_38, "缺交")) : _createCommentVNode("", true), row.awaitingEvaluation ? (_openBlock(), _createElementBlock("span", _hoisted_39, "待评价")) : _createCommentVNode("", true), row.supplementRequested ? (_openBlock(), _createElementBlock("span", _hoisted_40, "待补充")) : _createCommentVNode("", true), !(row.planLate || row.summaryLate || row.planMissing || row.summaryMissing) && !row.awaitingEvaluation && !row.supplementRequested ? (_openBlock(), _createElementBlock("span", _hoisted_41, "--")) : _createCommentVNode("", true)])]), _createElementVNode("td", _hoisted_42, [_createElementVNode("button", {
            type: "button",
            class: "table-action-button is-primary",
            title: "查看日报详情",
            "aria-label": "查看日报详情",
            onClick: $event => openDetail(row)
          }, [_createVNode(_unref(EyeIcon), {
            class: "h-4 w-4"
          })], 8, _hoisted_43)])]);
        }), 128))])])]))]), !loading.value && !loadError.value && pagination.total > 0 ? (_openBlock(), _createBlock(AppPagination, {
          key: 0,
          current: pagination.current,
          size: pagination.size,
          total: pagination.total,
          pages: pagination.pages,
          class: "pagination-bridge",
          onPageChange: handlePageChange,
          onSizeChange: handleSizeChange
        }, null, 8, ["current", "size", "total", "pages"])) : _createCommentVNode("", true)])]), _createVNode(ReportDetailDrawer, {
          "model-value": drawerVisible.value,
          detail: selectedDetail.value,
          loading: detailLoading.value,
          "can-evaluate": canOperateOnDetail.value,
          "can-request-supplement": detailCanRequestSupplement.value,
          "can-comment": detailCanComment.value,
          "evaluation-submitting": evaluationSubmitting.value,
          "supplement-submitting": supplementSubmitting.value,
          "operation-submitting": detailOperationSubmitting.value,
          "supplement-reset-token": supplementResetToken.value,
          "selected-version": selectedDetailVersion.value,
          "version-loading": detailVersionLoading.value,
          "initial-tab": detailInitialTab.value,
          "focus-comment-id": notificationFocusCommentId.value,
          "onUpdate:modelValue": handleDrawerVisibleChange,
          onEvaluate: handleEvaluation,
          onRequestSupplement: handleSupplement,
          onComment: handleComment,
          onSelectVersion: loadDetailVersion
        }, null, 8, ["model-value", "detail", "loading", "can-evaluate", "can-request-supplement", "can-comment", "evaluation-submitting", "supplement-submitting", "operation-submitting", "supplement-reset-token", "selected-version", "version-loading", "initial-tab", "focus-comment-id"]), _createVNode(DepartmentRuleDrawer, {
          "model-value": departmentRuleDrawerVisible.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => departmentRuleDrawerVisible.value = $event)
        }, null, 8, ["model-value"]), (_openBlock(), _createBlock(_Teleport, {
          to: "body"
        }, [_createVNode(AppModal, {
          visible: showExportModal.value,
          size: "md",
          "z-index": 70,
          scrollable: false,
          onClose: closeExportDialog
        }, {
          default: _withCtx(() => [_createElementVNode("header", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createElementVNode("span", _hoisted_47, [_createVNode(_unref(ArrowDownTrayIcon), {
            class: "h-5 w-5"
          })]), _createElementVNode("h2", _hoisted_48, _toDisplayString(exportDialogTitle.value), 1)])]), _createElementVNode("button", {
            type: "button",
            class: "rounded-lg p-1.5 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600",
            title: "关闭",
            "aria-label": "关闭",
            disabled: exporting.value,
            onClick: closeExportDialog
          }, [_createVNode(_unref(XMarkIcon), {
            class: "h-5 w-5"
          })], 8, _hoisted_49)]), _createElementVNode("div", _hoisted_50, [_createElementVNode("section", _hoisted_51, [_createElementVNode("div", _hoisted_52, [_cache[13] || (_cache[13] = _createElementVNode("span", {
            class: "text-sm font-medium text-slate-700"
          }, "日期区间", -1)), _createElementVNode("div", _hoisted_53, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(EXPORT_RANGE_PRESETS, preset => {
            return _createElementVNode("button", {
              key: preset.label,
              type: "button",
              class: _normalizeClass(["rounded-full px-2.5 py-1 text-xs font-medium transition-colors", isExportPresetActive(preset) ? 'bg-blue-600 text-white shadow-sm' : 'bg-slate-100 text-slate-600 hover:bg-slate-200']),
              disabled: exporting.value,
              onClick: $event => applyExportPreset(preset)
            }, _toDisplayString(preset.label), 11, _hoisted_54);
          }), 64))])]), _createElementVNode("div", _hoisted_55, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => exportRange.value.startDate = $event),
            class: "form-input form-control-sm w-full",
            type: "date",
            "aria-label": "导出开始日期",
            max: exportRange.value.endDate || undefined,
            disabled: exporting.value
          }, null, 8, _hoisted_56), [[_vModelText, exportRange.value.startDate]]), _cache[14] || (_cache[14] = _createElementVNode("span", {
            class: "shrink-0 text-xs text-slate-400"
          }, "至", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => exportRange.value.endDate = $event),
            class: "form-input form-control-sm w-full",
            type: "date",
            "aria-label": "导出结束日期",
            min: exportRange.value.startDate || undefined,
            disabled: exporting.value
          }, null, 8, _hoisted_57), [[_vModelText, exportRange.value.endDate]])])]), _createElementVNode("section", _hoisted_58, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_59, [_cache[15] || (_cache[15] = _createElementVNode("span", {
            class: "text-sm font-medium text-slate-700"
          }, "导出员工", -1)), exportEmployeeUserIds.value.length ? (_openBlock(), _createElementBlock("span", _hoisted_60, " 已选 " + _toDisplayString(exportEmployeeUserIds.value.length) + " 人 ", 1)) : _createCommentVNode("", true)]), _createVNode(_component_el_select, {
            modelValue: exportEmployeeUserIds.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => exportEmployeeUserIds.value = $event),
            class: "export-select-multi mt-1.5 w-full",
            multiple: "",
            clearable: "",
            filterable: "",
            "collapse-tags": "",
            "collapse-tags-tooltip": "",
            "max-collapse-tags": 4,
            placeholder: "全部员工（可多选、可搜索）",
            loading: exportOptionsLoading.value,
            disabled: exporting.value,
            "aria-label": "导出员工"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(exportOptions.value.employees, employee => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: employee.id,
                label: employee.name,
                value: employee.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue", "loading", "disabled"])]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_61, [_cache[16] || (_cache[16] = _createElementVNode("span", {
            class: "text-sm font-medium text-slate-700"
          }, "导出部门", -1)), exportDeptIds.value.length ? (_openBlock(), _createElementBlock("span", _hoisted_62, " 已选 " + _toDisplayString(exportDeptIds.value.length) + " 个 ", 1)) : _createCommentVNode("", true)]), _createVNode(_component_el_select, {
            modelValue: exportDeptIds.value,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => exportDeptIds.value = $event),
            class: "export-select-multi mt-1.5 w-full",
            multiple: "",
            clearable: "",
            filterable: "",
            "collapse-tags": "",
            "collapse-tags-tooltip": "",
            "max-collapse-tags": 4,
            placeholder: "全部部门（可多选、可搜索）",
            loading: exportOptionsLoading.value,
            disabled: exporting.value,
            "aria-label": "导出部门"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(exportDeptOptionRows.value, dept => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: dept.id,
                label: dept.label,
                value: dept.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue", "loading", "disabled"])]), _createElementVNode("div", {
            class: _normalizeClass(["pointer-events-none flex items-center gap-2 text-xs text-slate-400 transition-opacity duration-150", exportOptionsLoading.value ? 'opacity-100' : 'opacity-0']),
            "aria-hidden": "true"
          }, [...(_cache[17] || (_cache[17] = [_createElementVNode("div", {
            class: "app-spinner is-xs"
          }, null, -1), _createTextVNode(" 正在加载可选范围... ", -1)]))], 2)]), _cache[18] || (_cache[18] = _createElementVNode("p", {
            class: "rounded-lg border border-blue-100 bg-blue-50 px-3 py-2 text-xs leading-5 text-blue-700"
          }, " 不选择即导出可见范围内全部日报；员工与部门同时选择时取交集，同类多选为并集。 ", -1))]), _createElementVNode("footer", _hoisted_63, [_createElementVNode("span", _hoisted_64, _toDisplayString(exportSummaryText.value), 1), _createElementVNode("div", _hoisted_65, [_createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            disabled: exporting.value,
            onClick: closeExportDialog
          }, "取消", 8, _hoisted_66), _createElementVNode("button", {
            type: "button",
            class: "btn-primary inline-flex items-center gap-1.5",
            disabled: exporting.value || exportOptionsLoading.value,
            onClick: handleExport
          }, [_createVNode(_unref(ArrowDownTrayIcon), {
            class: "h-4 w-4"
          }), _createTextVNode(" " + _toDisplayString(exporting.value ? '导出中...' : '导出 xlsx'), 1)], 8, _hoisted_67)])])]),
          _: 1
        }, 8, ["visible"])]))]),
        _: 1
      });
    };
  }
};